import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { INTEGRATION_CONFIG_STEP_ACTION_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_integration_config_step_action_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { TriggerStep, TriggerType } from '@/types/automationSteps.ts';
import { IntegrationAction } from '@/types/integrations.ts';

const useRetrieveIntegrationActionForStep = (
  automationId?: string,
  triggerStep?: TriggerStep,
): UseQueryResult<IntegrationAction, AxiosError> => {
  const apiClient = useApiClient();
  const stepId = triggerStep?.step_id;

  return useQuery({
    queryKey: INTEGRATION_CONFIG_STEP_ACTION_KEY(automationId || '', stepId || ''),
    queryFn: async () => {
      const response = await apiClient.get<IntegrationAction>(
        get_integration_config_step_action_url(automationId || '', stepId || ''),
      );
      return response.data;
    },
    enabled: !!automationId && !!stepId && triggerStep?.trigger_type === TriggerType.External,
  });
};

export default useRetrieveIntegrationActionForStep;
